import { Shield, FileText, Mail } from 'lucide-react';

export default function Terms() {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Hero Section */}
      <div className="bg-[#003366] py-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <div className="w-16 h-16 mx-auto bg-[#FFD700]/20 rounded-full flex items-center justify-center mb-4">
            <FileText className="w-8 h-8 text-[#FFD700]" />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">Terms of Service</h1>
          <p className="text-slate-300">Last updated: March 20, 2026</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-xl shadow-sm p-8 space-y-8">
          
          <section>
            <h2 className="text-xl font-bold text-[#003366] mb-4">1. Agreement to Terms</h2>
            <p className="text-slate-600 leading-relaxed">
              By accessing or using the IPVALUE MANAGEMENTS website and services, you agree to be bound by these 
              Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#003366] mb-4">2. Use of Our Services</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              You may use our services only as permitted by these terms and applicable laws. You agree not to:
            </p>
            <ul className="list-disc list-inside text-slate-600 space-y-2 ml-4">
              <li>Use our services for any illegal purpose or in violation of any laws</li>
              <li>Attempt to gain unauthorized access to our systems or networks</li>
              <li>Interfere with or disrupt our services or servers</li>
              <li>Use automated systems or software to extract data from our website</li>
              <li>Impersonate any person or entity</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#003366] mb-4">3. Account Registration</h2>
            <p className="text-slate-600 leading-relaxed">
              To make purchases, you may need to create an account. You are responsible for maintaining 
              the confidentiality of your account information and for all activities under your account. 
              You must provide accurate and complete information during registration.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#003366] mb-4">4. Products and Pricing</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              We strive to provide accurate product information and pricing. However, we reserve the right to:
            </p>
            <ul className="list-disc list-inside text-slate-600 space-y-2 ml-4">
              <li>Correct any errors in pricing or product descriptions</li>
              <li>Cancel orders if pricing errors occur</li>
              <li>Limit quantities available for purchase</li>
              <li>Discontinue products without prior notice</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#003366] mb-4">5. Orders and Payment</h2>
            <p className="text-slate-600 leading-relaxed">
              All orders are subject to acceptance and availability. We accept major credit cards and 
              process payments securely through Square. By placing an order, you authorize us to charge 
              your payment method for the total order amount including applicable taxes and shipping.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#003366] mb-4">6. Shipping and Delivery</h2>
            <p className="text-slate-600 leading-relaxed">
              Shipping times and costs vary based on location and shipping method selected. We are not 
              responsible for delays caused by shipping carriers, customs, or other factors beyond our 
              control. Risk of loss passes to you upon delivery to the carrier.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#003366] mb-4">7. Returns and Refunds</h2>
            <p className="text-slate-600 leading-relaxed">
              We offer a 30-day return policy for most items in their original condition. Some products 
              may have specific return restrictions. Refunds will be processed to the original payment 
              method within 5-10 business days after we receive the returned item.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#003366] mb-4">8. Age Restrictions</h2>
            <p className="text-slate-600 leading-relaxed">
              Certain products on our website are restricted to customers 18 years of age or older. 
              By purchasing age-restricted products, you confirm that you meet the minimum age requirement. 
              We reserve the right to cancel orders if age verification fails.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#003366] mb-4">9. Intellectual Property</h2>
            <p className="text-slate-600 leading-relaxed">
              All content on this website, including text, graphics, logos, images, and software, is the 
              property of IPVALUE MANAGEMENTS or its content suppliers and is protected by intellectual 
              property laws. You may not reproduce, distribute, or create derivative works without our 
              written permission.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#003366] mb-4">10. Limitation of Liability</h2>
            <p className="text-slate-600 leading-relaxed">
              To the maximum extent permitted by law, IPVALUE MANAGEMENTS shall not be liable for any 
              indirect, incidental, special, consequential, or punitive damages arising from your use 
              of our services or products.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#003366] mb-4">11. Changes to Terms</h2>
            <p className="text-slate-600 leading-relaxed">
              We may update these terms from time to time. We will notify you of material changes by 
              posting the new terms on our website. Your continued use of our services after changes 
              constitutes acceptance of the updated terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#003366] mb-4">12. Contact Us</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              If you have questions about these Terms of Service, please contact us:
            </p>
            <div className="flex items-center gap-2 text-[#003366]">
              <Mail className="w-5 h-5" />
              <a href="mailto:support@ipvaluemanagements.com" className="hover:underline">
                support@ipvaluemanagements.com
              </a>
            </div>
          </section>

        </div>
      </div>
    </div>
  );
}
